import React from 'react';
import { useNavigate } from 'react-router-dom';
import DynamicBackground from '../../components/DynamicBackground';
import CreditsDisplay from '../../components/CreditsDisplay';
import ExpertContactMessage from '../../components/ExpertContactMessage';
import { useUser } from '../../contexts/UserContext';
import '../../styles/darkMode.css';
import './ContractGenerator.css';

interface GeneratorTool {
  title: string;
  description: string;
  category: string;
  path: string;
}

const ContractGenerator: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useUser();

  const generatorTools: GeneratorTool[] = [
    {
      title: 'Record Deal Generator',
      description: 'Create and customize record deal agreements',
      category: 'Generator',
      path: '/record-deal-form'
    },
  ];

  return (
    <DynamicBackground>
      <div className="dark-container">
        <div className="user-header">
          {user?.picture && (
            <img 
              src={user.picture} 
              alt={`${user.name}'s profile`} 
              className="user-profile-picture"
            />
          )}
          <CreditsDisplay variant="header" />
          <div className="user-welcome">
            <h1 className="dark-title">
              Contract Generator
            </h1>
            <p className="dark-subtitle">Choose a contract generation tool</p>
          </div>
        </div>
        
        <div className="toolsGrid">
          {generatorTools.map((tool, index) => (
            <div 
              key={index} 
              className="dark-card toolCard"
              onClick={() => navigate(tool.path)}
            >
              <h3 className="dark-text">{tool.title}</h3>
              <p className="dark-text-muted category">{tool.category}</p>
              <p className="dark-text description">{tool.description}</p>
            </div>
          ))}
        </div>

        <div className="coming-soon-message">
          <div className="dark-card">
            <h3 className="dark-text">More contract generation tools coming soon!</h3>
            <p className="dark-text-muted">
              We're working on additional contract generators to help you create various types of music industry agreements.
            </p>
          </div>
        </div>

        <ExpertContactMessage />
      </div>
    </DynamicBackground>
  );
};

export default ContractGenerator;
